// extracted by mini-css-extract-plugin
export default {"container":"styles_container__GY0Y9","answerBtn":"styles_answerBtn__DQCh2","active":"styles_active__djIQW"};